export async function addSpaceGameQuestion({
  id,
  questionText,
  optionA,
  optionB,
  optionC,
  optionD,
  correctAnswer,
  timerSeconds,
  points,
  token,
}) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/addSpaceGameQuestion`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token || ""}`,
    },
    body: JSON.stringify({
      id,
      questionText,
      optionA,
      optionB,
      optionC,
      optionD,
      correctAnswer,
      timerSeconds,
      points,
    }),
  });

  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) {
    throw new Error(data?.message || "Failed to save question");
  }
  return data;
}
